import { useMutation } from "react-query";
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from '../../global_state'
import { add_new_position } from "../../services/jobs";


const useAddPosition = () => {
  const set_error = useSetRecoilState(error_message)
  const set_success = useSetRecoilState(success_message)

  return  useMutation((position_name)=>add_new_position(position_name), {
      onSuccess: data => {
        set_success('Successfully added position!')
        setTimeout(() => {
          set_success('')
        }, 4000);
      },
      onError: () => {
        set_error(`Position already exists!`)
        setTimeout(() => {
          set_error('')
        }, 4000);
      }
  })
}

export default useAddPosition;
